module.exports = __webpack_public_path__ + "SP_SPS10-Recess-eb8e684807dd36f1876aedd8850b9461.png";